module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "empty-my-bookings-disable.09c5844f.png";